import type { ReactNode } from 'react';

export function Panel({ title, children, className = '' }: { title: string; children: ReactNode; className?: string }) {
  return (
    <section className={`panel ${className}`}>
      <h2>{title}</h2>
      {children}
    </section>
  );
}

export function Metric({ label, value }: { label: string; value?: ReactNode }) {
  return (
    <div className="metric">
      <strong>{label}</strong>
      <span>{value || '-'}</span>
    </div>
  );
}

export function EmptyState({ children }: { children: ReactNode }) {
  return <div className="empty-state">{children}</div>;
}

export function ErrorState({ error }: { error: unknown }) {
  return <div className="error-state">{formatError(error)}</div>;
}

export function formatError(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object') {
    const record = error as Record<string, unknown>;
    const message = record.message || record.error_description || record.details || record.code;
    if (message) return String(message);
    try {
      return JSON.stringify(error);
    } catch {
      return 'Error desconocido';
    }
  }
  return String(error);
}
